import { type } from "../types/index.js";

export const hideModalError = () => (dispatch) => {
    dispatch({
        type: type.closetError
    });
}